import React from 'react';
import { useFelaEnhanced } from '@ackee/fela';
import * as felaRules from './PagesRangeDelimiter.rules';

export interface PagesRangeDelimiterProps {}

export const PagesRangeDelimiter = ({}: PagesRangeDelimiterProps) => {
    const { styles } = useFelaEnhanced(felaRules);

    return <span className={styles.delimiter}>…</span>;
};
